import { render, staticRenderFns } from "./TopupsPaymentSheetComponent.vue?vue&type=template&id=c5c1dbac&"
import script from "./TopupsPaymentSheetComponent.vue?vue&type=script&lang=js&"
export * from "./TopupsPaymentSheetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports